import script from "./CategoriesDialogView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesDialogView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__